import { render, staticRenderFns } from "./form.item.com.vue?vue&type=template&id=a067c866&scoped=true&"
import script from "./form.item.com.vue?vue&type=script&lang=js&"
export * from "./form.item.com.vue?vue&type=script&lang=js&"
import style0 from "./form.item.com.vue?vue&type=style&index=0&id=a067c866&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a067c866",
  null
  
)

export default component.exports